import { Util } from '@antv/g6';
import { DrawOpts } from '../../../../types';
import { shapeNames, ButtonType } from '../../../../shapes/constants';
import { addTooltip } from '../../../../shapes/utils';
import { getTitleHeight } from './text';

/* ---------------------------------- Link ---------------------------------- */

const getIconPaddingTop = ({ options, model }: Pick<DrawOpts, 'options' | 'model'>) =>
  (getTitleHeight({ options, model }) - options[shapeNames.linkIcon].height) / 2;

const getLinkAttrs = ({ options, model }: Pick<DrawOpts, 'options' | 'model'>) => {
  const iconConfig = options[shapeNames.linkIcon];
  const [paddingTop, , , paddingLeft] = Util.formatPadding(options[shapeNames.wrapper].padding);

  return {
    x: paddingLeft,
    y: paddingTop + getIconPaddingTop({ options, model }),
    ...iconConfig,
  };
};

export const drawLinkIcon = ({ group, options, model }: DrawOpts) => {
  const linkShape = group.addShape('image', {
    buttonType: ButtonType.Link,
    name: shapeNames.linkIcon,
    className: shapeNames.linkIcon,
    draggable: true,
    attrs: getLinkAttrs({ options, model }),
  });

  addTooltip({ shape: linkShape, text: 'Copy link' });

  if (!model?.isLinkButtonVisible) {
    linkShape.hide();
  }

  return linkShape;
};

export const updateLinkIcon = ({ group, model }: DrawOpts) => {
  const linkShape = group.findByClassName(shapeNames.linkIcon);

  if (model?.isLinkButtonVisible) {
    linkShape.show();
  } else {
    linkShape.hide();
  }
};
